module.exports = __webpack_public_path__ + "static/img/main_point_img08.ec1c3a31.svg";